<script>
    import NormalSearch from "./components/NormalSearch.vue";
    import OrderModal from "./components/OrderModal";

    export default {
        components: { NormalSearch, OrderModal  },
        data() {
            return {
                productOrders: [],
                params: {
                    page: 1,
                    perPage: 100,
                    sorts: [{ columnName: "id", type: "asc" }],
                    status: 'all',
                    keyword: null,
                    productCategory: 'all',
                    showProductionOnly: true
                },
                canScroll: false,
                loading: false,
                totalRows: 0,
                barcode: null,
                categories: [
                  'boxershorts',
                  'cardigan',
                  'cashmerepullover',
                  'ties',
                  'handkerchief',
                  'bowties',
                  'braces',
                  'cufflinks',
                  'bracelets',
                  'scarf',
                  'socks',
                  'masks'
                ]
            };
        },

        watch: {
            $route: function () {
                this.productOrders = [];
                this.params.page = 1;
                this.params.status = this.$route.params.status;
                this.getPageData();
            },
        },

        mounted() {
            this.params.status = this.$route.params.status;
            this.params.showProductionOnly = (this.$route.params.status !== "sent_to_germany");
            this.getPageData();
            this.scroll();
        },

        methods: {
            async getPageData() {
                this.canScroll = false;
                this.loading = true;

                let params = { ...this.params };
                params["showProductionOnly"] = params.showProductionOnly ? 1 : 0;
                let result = await axios.get("product_orders/listing", { params });
                this.totalRows = result.data.totalRows;
                result = result.data.data;
                result.forEach((val) => {
                    val.documentPrintedButtonClicked = val.document_printed_date !== null;
                    this.productOrders.push(val);
                });
                if (result.length < this.params.perPage) {
                    this.canScroll = false;
                } else {
                    this.canScroll = true;
                    this.params.page++;
                }
                this.loading = false;
            },

            resetPage() {
                this.params.page = 1;
                this.productOrders = [];
            },

            async changeStatus(orderId) {
                try {
                    let res = await axios.post("product_orders/scan/" + orderId, {
                        status: 'started',
                    });
                    if (res) {
                        const index = this.productOrders.findIndex(order => order.id === orderId);
                        if (index !== -1) {
                            this.productOrders[index].status = 'started';
                        }
                        toastr.success("Success");
                    }
                } catch (err) {
                    this.message = orderId;
                    let message = err.response.data.message;
                    Swal.fire({
                        title: "ERROR",
                        html: message,
                        type: "warning",
                    });
                }
            },

            newOrder() {
            show_modal("#order-modal");
            },

            sort(column) {
                let currentSortDirection = this.params.sorts[0].type;
                let newSortDirection = (currentSortDirection === "desc") ? "asc" : "desc";

                this.params.sorts = [
                    {
                        columnName: column,
                        type: newSortDirection
                    }
                ];

                this.resetPage();
                this.getPageData();
            },

            searchByKeyword(keyword) {
                this.$router.push("/product_order/detail/" + keyword);
            },

            onParamsChange() {
                this.resetPage();
                this.getPageData();
            },

            scroll() {
                let self = this;
                window.onscroll = () => {
                    var elem = document.getElementsByClassName("page-content")[0];
                    if (self.canScroll === true) {
                    if (
                        document.documentElement.scrollTop +
                        document.documentElement.offsetHeight >=
                        elem.scrollHeight
                    ) {
                        self.getPageData();
                    }
                    }
                };
            },

            async printProductionSheet(productOrder) {
                await ezy.openPDFInNewWindow(`product_orders/production_sheet/${productOrder.id}`)
            },

            async printPattern(productOrder) {
                await ezy.openPDFInNewWindow(`product_orders/pattern/${productOrder.id}`)
            },
            getFormattedConfiguration(configuration, color) {
                if(!configuration) return '';
                let formattedConfiguration = [];

                if(color) {
                    formattedConfiguration.push(`Color: ${color}`)
                }

                for (const [key, value] of Object.entries(configuration)) {
                    let label = key;
                    switch (key) {
                        case 'fabric_id':
                            label = 'Fabric';
                            break;
                        case 'contrast_fabric_id':
                            label = 'Contrast';
                            break;
                        case 'length':
                            label = 'Length';
                            break;
                        case 'size':
                            label = 'Size';
                            break;
                        case 'version':
                            label = 'Version';
                            break;
                    }
                    if(value != 0) {
                        formattedConfiguration.push(`${label}: ${value}`)
                    }
                }
                return formattedConfiguration.join('<br/>')
            }
        },
    }
</script>

<template>
    <div>
        <NormalSearch :serverParams="params" @submit="onParamsChange"/>
        <div class="grid bg-white">
            <div class="grid-title">
                <h5 class="text-bold">Simple Configurable Products</h5>
            </div>

            <div class="grid-body">
                 <div id="product-orders-overview-top-navigation" class="row justify-content-between">
                        <div class="col-md-3">
                            <input
                                type="text"
                                placeholder="Product Order ID"
                                class="form-control"
                                @keyup.enter="searchByKeyword($event.target.value)"
                            /><br />
                        </div>
                        <div class="col-md-9 float-right text-right" v-if="$ProductOrder.getProductOrderUserRoles().includes($auth.user().role) || $ProductOrder.getProductOrderUserEmails().includes($auth.user().email)">
                            <button
                                class="btn btn-primary"
                                @click="newOrder"
                            >
                                <i class="fa fa-plus-circle" aria-hidden="true"></i> New Order
                            </button>
                        </div>
                    </div>
                <div id="product-orders-overview-listings-container" class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th @click="sort('id')">
                                    <i class="fa fa-sort"></i> ID
                                </th>
                                <th @click="sort('product_name')">
                                    <i class="fa fa-sort"></i> Product
                                </th>
                                <th @click="sort('consultant_id')" class="configuration-header">
                                    <i class="fa fa-sort"></i> Configurations
                                </th>

                                <th @click="sort('consultant_id')">
                                    <i class="fa fa-sort"></i> Customer
                                </th>

                                <th @click="sort('quantity')">
                                    <i class="fa fa-sort"></i> Quantity
                                </th>
                                <th @click="sort('status')">
                                    <i class="fa fa-sort"></i> Item Statuses
                                </th>
                                <th class="text-center">Documents /  Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(productOrder,index) in productOrders" :key="index">
                                <td class="text-bold">
                                    <router-link :to="'/product_order/detail/' + productOrder.id"
                                    >#{{ productOrder.id }}</router-link
                                    >
                                </td>
                                <td>{{ productOrder.product_name }}</td>
                                <td v-html="getFormattedConfiguration(productOrder.configuration, productOrder.color)"></td>
                                <td>{{ productOrder.consultant_id }}</td>
                                <td>{{ productOrder.quantity }}</td>
                                <td>
                                  <router-link
                                  :to="{ name: 'product_order_details', params: { id: productOrder.id } }"
                                  v-for="item in productOrder.items_statuses" :class="'item-status ' + item.status"
                                  >
                                    {{ item.id }} | {{ item.status }}
                                  </router-link>
                                </td>
                                <td v-if="(categories.includes(productOrder.product_category))" class="text-bold text-center">
                                    <div v-if="productOrder.status === 'imported'">
                                        <a
                                        @click="changeStatus(productOrder.id)"
                                        class="btn btn-primary btn-sm"
                                        >
                                        Started
                                        </a>
                                    </div>
                                </td>
                                <td v-else class="text-bold text-center">
                                    <a v-if="productOrder.can_print_production_sheet"
                                    @click="printProductionSheet(productOrder)" class="action-button"
                                       :class="{
                                            'btn btn-primary btn-sm': !productOrder.is_production_sheet_printed,
                                            'btn btn-success btn-sm': productOrder.is_production_sheet_printed,
                                       }"
                                    >
                                    Print Production Sheet
                                    </a>
                                    <span v-else class="btn btn-sm btn-disabled action-button">Print Production Sheet</span>
                                    <a  v-if="productOrder.can_print_pattern"
                                       @click="printPattern(productOrder)"  class="action-button"
                                       :class="{
                                        'btn btn-primary btn-sm': !productOrder.is_pattern_printed,
                                        'btn btn-success btn-sm':
                                          productOrder.is_pattern_printed,
                                      }"
                                    >
                            Print Pattern
                        </a>
                                    <span v-else class="btn btn-sm btn-disabled action-button">Print Pattern</span>
                                </td>
                            </tr>

                            <tr v-if="loading">
                                <td colspan="13" class="text-center">
                                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                                    Loading ...
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <order-modal/>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .configuration-header {
        min-width: 200px;
    }
    .action-button {
        margin-bottom: 5px;
    }
</style>
